import { render } from "./btn-back.vue?vue&type=template&id=79983615&scoped=true&ts=true"
import script from "./btn-back.vue?vue&type=script&lang=ts"
export * from "./btn-back.vue?vue&type=script&lang=ts"

import "./btn-back.vue?vue&type=style&index=0&id=79983615&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79983615"]])

export default __exports__